import React from 'react';

export const PricingPlanSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 ">

      <style>{`
        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position:  600px 0; }
        }

        .sk {
          background: linear-gradient(
            90deg,
            #d4cafc 25%,
            #bfb3f7 50%,
            #d4cafc 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .sk-light {
          background: linear-gradient(
            90deg,
            #e8e3fb 25%,
            #d5cef5 50%,
            #e8e3fb 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .card {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

        .card-header {
  background: #c7bdef;
  padding: 28px 28px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  min-height: 224px;
}


        .sk-plan-name {
          height: 22px;
          width: 80px;
          border-radius: 6px;
        }

        .sk-price {
          height: 44px;
          width: 170px;
          border-radius: 8px;
        }

        .sk-btn {
          height: 46px;
          width: 100%;
          border-radius: 10px;
        }

        .card-body {
          background: #fff;
          padding: 24px 28px 28px;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .ideal-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          padding-bottom: 16px;
          border-bottom: 1.5px solid #ede9fe;
        }

        .sk-ideal-title {
          height: 20px;
          width: 100px;
        }

        .sk-ideal-sub {
          height: 16px;
          width: 190px;
        }

        .feature-list {
          display: flex;
          flex-direction: column;
          gap: 13px;
        }

        .feature-row {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .sk-check {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .sk-feat {
          height: 13px;
          border-radius: 5px;
        }
      `}</style>

      {[...Array(3)].map((_, cardIndex) => {
        const featureWidths = [68, 75, 62, 82, 55, 58, 50, 45, 88, 78];
        return (
          <div key={cardIndex} className="card">
            {/* Purple header */}
            <div className="card-header">
              <div className="sk sk-plan-name"></div>
              <div className="sk sk-price"></div>
              <div className="sk sk-btn"></div>
            </div>

            {/* White body */}
            <div className="card-body">
              {/* Ideal for block */}
              <div className="ideal-block">
                <div className="sk-light sk-ideal-title"></div>
                <div className="sk-light sk-ideal-sub"></div>
              </div>

              {/* Feature rows */}
              <div className="feature-list">
                {[...Array(10)].map((_, i) => (
                  <div key={i} className="feature-row">
                    <div className="sk-light sk-check"></div>
                    <div className="sk-light sk-feat" style={{ width: `${featureWidths[i]}%` }}></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
